import { type FC } from 'react';
import {
  LabelInShapeComponent, Shape, type SharedNumberProps,
} from '~/_shared/baseComponents/labelInShape/labelInShapeComponent';

export const LabelInCircleComponent: FC<SharedNumberProps> = ({ children, ...rest }) => (
  <LabelInShapeComponent
    {...rest}
    shape={Shape.circle}
  >
    {children}
  </LabelInShapeComponent>
);
